/**
 * Maps PreAssessment certification card id to web-service/parser certification_type.
 * @param {string|null|undefined} certId
 * @returns {'HALAL'|'SLHS'|'HACCP'}
 */
export function feCertToApi(certId) {
  if (certId === 'slhs') return 'SLHS';
  if (certId === 'haccp') return 'HACCP';
  return 'HALAL';
}

/**
 * URL segment under /pre-assessment/:certSlug → frontend cert id (halal | slhs | haccp).
 * @param {string|null|undefined} slug
 * @returns {'halal'|'slhs'|'haccp'|null}
 */
export function certSlugToFeId(slug) {
  const s = String(slug || '')
    .trim()
    .toLowerCase();
  if (s === 'slhs') return 'slhs';
  if (s === 'haccp') return 'haccp';
  if (s === 'halal') return 'halal';
  return null;
}

/**
 * @param {'halal'|'slhs'|'haccp'|string|null|undefined} feId
 * @returns {'HALAL'|'SLHS'|'HACCP'}
 */
export function feCertIdToPackageCode(feId) {
  if (feId === 'slhs') return 'SLHS';
  if (feId === 'haccp') return 'HACCP';
  return 'HALAL';
}

/** @param {string|null|undefined} packageCode e.g. HALAL from active_packages */
export function packageCodeToFeId(packageCode) {
  const u = String(packageCode || '')
    .trim()
    .toUpperCase();
  if (u === 'SLHS') return 'slhs';
  if (u === 'HACCP') return 'haccp';
  if (u === 'HALAL') return 'halal';
  return null;
}

/**
 * Canonical path segment for pre-assessment URL.
 * @param {'halal'|'slhs'|'haccp'|string|null|undefined} feId
 */
export function feCertSlugFromFeId(feId) {
  if (feId === 'slhs') return 'slhs';
  if (feId === 'haccp') return 'haccp';
  return 'halal';
}

/**
 * @param {'halal'|'slhs'|'haccp'|string|null|undefined} feId
 */
export function preAssessmentPathForFeId(feId) {
  return `/pre-assessment/${feCertSlugFromFeId(feId)}`;
}

export { preAssessmentHrefForPathname } from '@/lib/pemohonCertFlow';
